<template>
  <v-row>
    <v-col
      cols="4"
      sm="4"
      lg="3"
      class="pt-0"
      v-for="card in cards"
      :key="card.id"
    >
      <v-card elevation="0">
        <v-card-title>
          <p class="text-caption grey--text">{{ card.title }}</p>
          <v-spacer></v-spacer>
          <v-icon :color="card.color" class="custom-icon">
            {{ card.icon }}
          </v-icon>
        </v-card-title>
        <v-card-text>
          <div class="text-right text-h5 text-sm-h4 font-weight-bold">
            <template v-if="card.title === '월급일'">
              <span>{{ card.text }}</span>
              <div class="confetti" ref="confetti">
                <template v-if="!!effects.length">
                  <span
                    v-for="effect in effects"
                    :key="effect.id"
                    :class="`particle c${effect.name}`"
                    :style="effect.styles"
                  ></span>
                </template>
              </div>
            </template>
            <div v-else>{{ card.text }}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      cards: [
        {
          id: 1,
          icon: "mdi-calendar-blank",
          title: "TODAY",
          text: "",
          color: "#B3DB00",
        },
        {
          id: 2,
          icon: "mdi-airplane-takeoff",
          title: "잔여 휴가일 수",
          text: "11.5",
          color: "#FF96A1",
        },
        {
          id: 3,
          icon: "mdi-piggy-bank-outline",
          title: "월급일",
          text: "",
          color: "#6AB4D9",
        },
        {
          id: 4,
          icon: "mdi-account-tie",
          title: "입사일",
          text: "+1280",
          color: "#fbd887",
        },
      ],
      effects: [],
    };
  },
  mounted() {
    const today = moment(new Date()).startOf("day");
    const year = today.year();
    const date = today.date();
    const month = date <= 25 ? today.month() : today.month() + 1;
    const payday = moment(new Date(year, month, 25));
    const diffDay = moment.duration(today.diff(payday)).days();

    this.cards[0].text = today.format("M/D");
    this.cards[2].text = `D${diffDay === 0 ? "-Day" : diffDay}`;

    if (diffDay === 0) {
      const effects = [];
      const confetticount = (this.$refs.confetti[0].clientWidth / 50) * 10;

      for (let i = 0; i <= confetticount; i++) {
        const type = {};
        const styles = {};
        type.id = i;
        type.name = this.rnd(1, 2);
        styles.top = `${this.rnd(10, 50)}%`;
        styles.left = `${this.rnd(0, 100)}%`;
        styles.width = `${this.rnd(6, 8)}px`;
        styles.height = `${this.rnd(3, 4)}px`;
        styles["animation-delay"] = `${this.rnd(0, 30) / 10}s`;

        effects.push({ ...type, styles: styles });
      }

      this.effects = effects;
    }
  },
  methods: {
    rnd(m, n) {
      m = parseInt(m);
      n = parseInt(n);
      return Math.floor(Math.random() * (n - m + 1)) + m;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-icon {
  margin-top: -13px;
}
.confetti {
  position: absolute;
  top: 20px;
  left: 10px;
  right: 10px;
  bottom: 10px;

  > .particle {
    opacity: 0;
    position: absolute;
    animation: confetti 3s ease-in infinite;
    &.c1 {
      background-color: rgba(76, 175, 80, 0.5);
    }
    &.c2 {
      background-color: rgba(156, 39, 176, 0.5);
    }
  }
}

@keyframes confetti {
  0% {
    opacity: 0;
    transform: translateY(0%) rotate(0deg);
  }
  10% {
    opacity: 1;
  }
  35% {
    transform: translateY(-800%) rotate(270deg);
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(2000%) rotate(1440deg);
  }
}
</style>
